import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, User, UserCredential } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { IS_PROD_ENV, IS_STAGING_ENV } from './constants';

const DevConfig = {
  apiKey: 'AIzaSyCKMH1SLB-dCKDyzeukb5u7PwIZTXYvACw',
  authDomain: 'thryve-dev.firebaseapp.com',
  databaseURL: 'https://thryve-dev.firebaseio.com',
  projectId: 'thryve-dev',
  storageBucket: 'thryve-dev.appspot.com',
  messagingSenderId: '1047393782048',
  appId: '1:1047393782048:web:ddf38a33f0564275446f45',
  measurementId: 'G-P38PB2TZ3L',
};

// staging is currently the same as dev as far as firebase goes. we may change this in the future
const StagingConfig = {
  apiKey: 'AIzaSyCKMH1SLB-dCKDyzeukb5u7PwIZTXYvACw',
  authDomain: 'thryve-dev.firebaseapp.com',
  databaseURL: 'https://thryve-dev.firebaseio.com',
  projectId: 'thryve-dev',
  storageBucket: 'thryve-dev.appspot.com',
  messagingSenderId: '1047393782048',
  appId: '1:1047393782048:web:ddf38a33f0564275446f45',
  measurementId: 'G-P38PB2TZ3L',
};

const ProdConfig = {
  apiKey: 'AIzaSyARPxCmm9NXQYbJoOgLlhZiEftKJnmkmCk',
  authDomain: 'thryve-prod.firebaseapp.com',
  databaseURL: 'https://thryve-prod.firebaseio.com',
  projectId: 'thryve-prod',
  storageBucket: 'thryve-prod.appspot.com',
  messagingSenderId: '472642641817',
  appId: '1:472642641817:web:1506defed9f76c954c3d08',
  measurementId: 'G-9J2FYYGF63',
};

const firebaseApp = initializeApp(IS_PROD_ENV ? ProdConfig : IS_STAGING_ENV ? StagingConfig : DevConfig);
export const auth = getAuth(firebaseApp);
export const analytics = getAnalytics(firebaseApp);
export { GoogleAuthProvider };

export const getAuthCurrentUserIdToken = async () => auth.currentUser?.getIdToken();
export type FirebaseUserCredential = UserCredential;
export type FirebaseUser = User;
